"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.serialize = exports.deserialize = exports.Serializable = exports.JsonProperty = void 0;
require("reflect-metadata");
var apiMap = 'api:map:';
var apiMapSerializable = apiMap + "serializable";
var designType = 'design:type';
var designParamTypes = 'design:paramtypes';
var Type;
(function (Type) {
    Type["Array"] = "array";
    Type["Boolean"] = "boolean";
    Type["Date"] = "date";
    Type["Number"] = "number";
    Type["Object"] = "object";
    Type["String"] = "string";
})(Type || (Type = {}));
function getBaseClassNames(target) {
    var names = [];
    var baseClass = Reflect.getPrototypeOf(target);
    if (!baseClass || !baseClass['name']) {
        return names;
    }
    names.push(baseClass['name']);
    return __spreadArrays(names, getBaseClassNames(baseClass));
}
function getPropertyNames(ctor) {
    var ctorWithoutComments = ctor.toString().replace(/(\/\*[\s\S]*?\*\/|\/\/.*$)/gm, '');
    var ctorOnSingleLine = ctorWithoutComments.replace(/[\r\t\n\v\f]/g, '');
    var ctorWithoutSuccessiveWhiteSpaces = ctorOnSingleLine.replace(/( +)/g, ' ');
    var constructorParamPattern = /(?:.*(?:constructor|function).*?(?=\())(?:\()(.+?(?=\)))/m;
    var propertyPattern = /(?:this\.)([^\n\r\t\f\v;]+)([\s;])/gm;
    var propertyNames = new Map();
    var paramsExecArray = constructorParamPattern.exec(ctorWithoutSuccessiveWhiteSpaces);
    if (!paramsExecArray || !paramsExecArray.length) {
        return propertyNames;
    }
    var params = paramsExecArray[1].replace(/ /g, '').split(',');
    var match;
    var _loop_1 = function () {
        var matchResult = match[1].replace(/ /g, '').split('=');
        var index = params.findIndex(function (param) { return param === matchResult[1]; });
        if (index > -1) {
            propertyNames.set(index, matchResult[0]);
        }
    };
    while ((match = propertyPattern.exec(ctorWithoutSuccessiveWhiteSpaces))) {
        _loop_1();
    }
    return propertyNames;
}
function JsonProperty(args) {
    return function (target, key, index) {
        if (key === undefined && target['prototype']) {
            var type = Reflect.getMetadata(designParamTypes, target)[index];
            var keys = getPropertyNames(target['prototype'].constructor);
            key = keys.get(index);
            target = target['prototype'];
            Reflect.defineMetadata(designType, type, target, key);
        }
        var map = {};
        var targetName = target.constructor.name;
        var apiMapTargetName = "" + apiMap + targetName;
        if (Reflect.hasMetadata(apiMapTargetName, target)) {
            map = Reflect.getMetadata(apiMapTargetName, target);
        }
        map[key] = getJsonPropertyValue(key, args);
        Reflect.defineMetadata(apiMapTargetName, map, target);
    };
}
exports.JsonProperty = JsonProperty;
function Serializable(options) {
    return function (target) {
        var baseClassNames = getBaseClassNames(target);
        Reflect.defineMetadata(apiMapSerializable, { baseClassNames: baseClassNames, options: options }, target);
    };
}
exports.Serializable = Serializable;
function getBaseClassMaps(baseClassNames, instance) {
    var baseClassMaps = {};
    baseClassNames.forEach(function (baseClassName) {
        baseClassMaps = __assign(__assign({}, baseClassMaps), Reflect.getMetadata("" + apiMap + baseClassName, instance));
    });
    return baseClassMaps;
}
function deserialize(json, type) {
    var _a;
    if ([null, undefined].includes(json)) {
        return json;
    }
    if (type === undefined) {
        return castSimpleData(typeof json, json);
    }
    var instance = new type();
    var instanceName = instance.constructor.name;
    var _b = (_a = Reflect.getMetadata(apiMapSerializable, type)) !== null && _a !== void 0 ? _a : {}, baseClassNames = _b.baseClassNames, options = _b.options;
    var apiMapInstanceName = "" + apiMap + instanceName;
    var hasMap = Reflect.hasMetadata(apiMapInstanceName, instance);
    var instanceMap = {};
    if (!hasMap && (!baseClassNames || !baseClassNames.length)) {
        return instance;
    }
    instanceMap = Reflect.getMetadata(apiMapInstanceName, instance);
    if (baseClassNames && baseClassNames.length) {
        instanceMap = __assign(__assign({}, instanceMap), getBaseClassMaps(baseClassNames, instance));
    }
    Object.keys(instanceMap).forEach(function (key) {
        var property = convertDataToProperty(instance, key, instanceMap[key], json, options === null || options === void 0 ? void 0 : options.formatPropertyNames);
        if (property !== undefined) {
            instance[key] = property;
        }
    });
    return instance;
}
exports.deserialize = deserialize;
function serialize(instance, removeUndefined) {
    var _a;
    if (removeUndefined === void 0) { removeUndefined = true; }
    if ([undefined, null].includes(instance) || typeof instance !== Type.Object) {
        return instance;
    }
    var instanceName = instance.constructor.name;
    var apiMapInstanceName = "" + apiMap + instanceName;
    var _b = (_a = Reflect.getMetadata(apiMapSerializable, instance.constructor)) !== null && _a !== void 0 ? _a : {}, baseClassNames = _b.baseClassNames, options = _b.options;
    var hasBaseClasses = baseClassNames && baseClassNames.length;
    var hasMap = Reflect.hasMetadata(apiMapInstanceName, instance);
    var instanceMap = {};
    if (!hasMap && !hasBaseClasses) {
        return instance;
    }
    instanceMap = Reflect.getMetadata(apiMapInstanceName, instance);
    if (hasBaseClasses) {
        instanceMap = __assign(__assign({}, instanceMap), getBaseClassMaps(baseClassNames, instance));
    }
    var json = {};
    var instanceKeys = Object.keys(instance);
    Object.keys(instanceMap).forEach(function (key) {
        var onSerialize = instanceMap[key]['onSerialize'];
        if (instanceKeys.includes(key)) {
            var metadata = instanceMap[key];
            var data_1 = convertPropertyToData(instance, key, metadata, removeUndefined);
            if (onSerialize) {
                data_1 = onSerialize(data_1, instance);
            }
            if (metadata['names']) {
                metadata['names'].forEach(function (name) {
                    if (!removeUndefined || (removeUndefined && data_1[name] !== undefined)) {
                        json[name] = data_1[name];
                    }
                });
            }
            else {
                if (!removeUndefined || (removeUndefined && data_1 !== undefined)) {
                    if (!metadata['isNameOverridden'] && (options === null || options === void 0 ? void 0 : options.formatPropertyNames)) {
                        var name_1 = options.formatPropertyNames(metadata['name']);
                        json[name_1] = data_1;
                    }
                    else {
                        json[metadata['name']] = data_1;
                    }
                }
            }
        }
    });
    return json;
}
exports.serialize = serialize;
function convertPropertyToData(instance, key, metadata, removeUndefined) {
    var property = instance[key];
    var type = Reflect.getMetadata(designType, instance, key);
    var isArray = type.name ? type.name.toLocaleLowerCase() === Type.Array : false;
    var predicate = metadata['predicate'];
    var propertyType = metadata['type'] || type;
    var isSerializableProperty = isSerializable(propertyType);
    if (property && (isSerializableProperty || predicate)) {
        if (isArray) {
            var array_1 = [];
            property.forEach(function (d) {
                array_1.push(serialize(d, removeUndefined));
            });
            return array_1;
        }
        if (metadata['isDictionary']) {
            var obj_1 = {};
            Object.keys(property).forEach(function (k) {
                obj_1[k] = serialize(property[k], removeUndefined);
            });
            return obj_1;
        }
        return serialize(property, removeUndefined);
    }
    if (propertyType.name.toLocaleLowerCase() === Type.Date) {
        return property ? property.toISOString() : property;
    }
    return property;
}
function convertDataToProperty(instance, key, metadata, json, formatPropertyName) {
    var data;
    if ([null, undefined].includes(json)) {
        return json;
    }
    if ('names' in metadata) {
        var object_1 = {};
        metadata.names.forEach(function (name) { return (object_1[name] = json[name]); });
        data = object_1;
    }
    else if ('name' in metadata && !metadata.isNameOverridden && formatPropertyName) {
        var name_2 = formatPropertyName(metadata.name);
        data = json[name_2];
    }
    else {
        data = json[metadata.name];
    }
    if ([null, undefined].includes(data)) {
        return data;
    }
    var type = Reflect.getMetadata(designType, instance, key);
    var isArray = type.name ? type.name.toLowerCase() === Type.Array : false;
    var isDictionary = metadata['isDictionary'];
    var predicate = metadata['predicate'];
    var onDeserialize = metadata['onDeserialize'];
    var postDeserialize = metadata['postDeserialize'];
    var propertyType = metadata['type'] || type;
    var isSerializableProperty = isSerializable(propertyType);
    var result;
    if (onDeserialize) {
        data = onDeserialize(data, instance);
    }
    if (!isSerializableProperty && !predicate) {
        result = castSimpleData(propertyType.name, data);
    }
    else if (isArray) {
        var array_2 = [];
        if (!Array.isArray(data)) {
            console.error(data + " is not an array.");
            result = undefined;
        }
        else {
            data.forEach(function (d) {
                if (predicate) {
                    propertyType = predicate(d);
                }
                array_2.push(deserialize(d, propertyType));
            });
            result = array_2;
        }
    }
    else if (isDictionary) {
        var obj_2 = {};
        if (typeof data !== Type.Object) {
            console.error(data + " is not an object.");
            result = undefined;
        }
        else {
            Object.keys(data).forEach(function (k) {
                if (predicate) {
                    propertyType = predicate(data[k]);
                }
                obj_2[k] = deserialize(data[k], propertyType);
            });
            result = obj_2;
        }
    }
    else {
        propertyType = predicate ? predicate(data) : propertyType;
        result = deserialize(data, propertyType);
    }
    if (postDeserialize) {
        result = postDeserialize(result, instance);
    }
    return result;
}
function isSerializable(type) {
    return Reflect.hasOwnMetadata(apiMapSerializable, type);
}
function getJsonPropertyValue(key, args) {
    if (!args) {
        return {
            name: key.toString(),
            type: undefined,
            onDeserialize: undefined,
            onSerialize: undefined,
            postDeserialize: undefined,
            isDictionary: false,
            isNameOverridden: false
        };
    }
    var metadata;
    if (typeof args === Type.String) {
        metadata = { name: args, isNameOverridden: true };
    }
    else if (args['name']) {
        metadata = { name: args['name'], isNameOverridden: true };
    }
    else if (args['names'] && args['names'].length) {
        metadata = { names: args['names'] };
    }
    else {
        metadata = { name: key.toString(), isNameOverridden: false };
    }
    return args['predicate']
        ? __assign(__assign({}, metadata), { predicate: args['predicate'], onDeserialize: args['onDeserialize'], onSerialize: args['onSerialize'], postDeserialize: args['postDeserialize'], isDictionary: !!args['isDictionary'] }) : __assign(__assign({}, metadata), { type: args['type'], onDeserialize: args['onDeserialize'], onSerialize: args['onSerialize'], postDeserialize: args['postDeserialize'], isDictionary: !!args['isDictionary'] });
}
function castSimpleData(type, data) {
    if (type === undefined || type === null) {
        return data;
    }
    type = type.toLowerCase();
    if ((typeof data).toLowerCase() === type) {
        return data;
    }
    switch (type) {
        case Type.String:
            return data ? data.toString() : data;
        case Type.Number:
            var number = +data;
            if (isNaN(number)) {
                console.error(data + ": Type " + typeof data + " is not assignable to type " + type + ".");
                return undefined;
            }
            return number;
        case Type.Boolean:
            console.error(data + ": Type " + typeof data + " is not assignable to type " + type + ".");
            return undefined;
        case Type.Date:
            if (isNaN(Date.parse(data))) {
                console.error(data + ": Type " + typeof data + " is not assignable to type " + type + ".");
                return undefined;
            }
            return new Date(data);
        default:
            return data;
    }
}
